module.exports = __webpack_public_path__ + "img/Hypoxia-LUCA_10X_LU.8d82bede.png";